import { defineMessages } from 'react-intl';

import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';

import coverDesktop from 'components/market/assets/manager_sales_desktop.jpg';
import cover from 'components/market/assets/manager_sales_mobile.jpg';
import { useCurrentMarketplaceUserContext } from 'contexts/currentMarketplaceUser';

import { OneTimeOnboardingDialog as OnboardingDialog } from '..';

const messages = defineMessages({
  title: {
    id: 'SalesOnboardingDialog.title',
    defaultMessage: 'Manager Sales',
  },
  description: {
    id: 'SalesOnboardingDialog.description',
    defaultMessage:
      'Scout the next superstar and buy player cards directly from other Sorare Managers',
  },
});

export const ManagersSales = ({
  open,
  onClick,
}: {
  open: boolean;
  onClick: () => void;
}) => {
  const { boughtSingleSaleTokenOffers } = useCurrentMarketplaceUserContext();

  return (
    <OnboardingDialog
      title={messages.title}
      description={messages.description}
      img={cover}
      imgDesktop={coverDesktop}
      lifecycleKey={LIFECYCLE.sawManagersSalesOnboarding}
      show={boughtSingleSaleTokenOffers?.hasAny === false}
      onClick={onClick}
      open={open}
    />
  );
};
